import React from "react";
import Select from "react-select";

const IndustryList = ({ onChange }) => {
  const options = [
    { value: "1", label: "Automotive" },
    { value: "2", label: "Consumer & retailer" },
    { value: "3", label: "Energy" },
    { value: "4", label: "Healthcare" },
    { value: "5", label: "Industrial & Aerospace" },
    { value: "6", label: "Technology" },
    { value: "7", label: "Other" },
  ];

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: "55px",
      height: "55px",
      borderRadius: "0px",
      border: state.isFocused ? "1px solid #021d49" : "1px solid #d9d9d9",
      boxShadow: state.isFocused ? "0 0 0 2px rgba(2, 29, 73, 0.2)" : "none",
      "&:hover": {
        borderColor: state.isFocused ? "#021d49" : "#d9d9d9",
      },
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#a6a6a6",
      fontSize: "1.6rem",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#f0f0f0" : "transparent",
      color: state.isSelected ? "#021d49" : "#333333",
      fontSize: "1.6rem",
      "&:hover": {
        backgroundColor: "#f0f0f0",
      },
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      color: "green",
      "&:hover": {
        color: "green",
      },
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    menu: (provided) => ({
      ...provided,
      marginTop: 0,
      borderRadius: "0px",
    }),
  };

  return (
    <Select
      options={options}
      placeholder="-Select-"
      styles={customStyles}
      onChange={onChange}
    />
  );
};

export default IndustryList;
